import React from "react";
import PropTypes from "prop-types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button, DotsGrid } from "@opendate-app/setlist";
import "./SortableTableRow.css";

const SortableTableRow = ({ id, handleLabel, sortable, disabled, className, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: !sortable || disabled });

  const rowClassName = [className, isDragging ? "sortable-table-row-dragging" : null].filter(Boolean).join(" ");

  return (
    <tr
      ref={setNodeRef}
      style={{ transform: CSS.Translate.toString(transform), transition }}
      className={rowClassName}
    >
      {sortable && (
        <td className="sortable-table-row-handle-cell">
          <Button
            variant="tertiary"
            size="xs"
            icon={DotsGrid}
            aria-label={handleLabel}
            className="sortable-table-row-handle"
            {...attributes}
            {...listeners}
          />
        </td>
      )}
      {children}
    </tr>
  );
};

SortableTableRow.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  handleLabel: PropTypes.string.isRequired,
  sortable: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

SortableTableRow.defaultProps = {
  sortable: true,
  disabled: false,
  className: undefined,
  children: null,
};

export default SortableTableRow;
